import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../helpers/reselectHelpers';
import {IntegrationTypeModel} from '../../models/api/integrationTypesModel';
import {AppState} from '../../store/appState';
import {getIsUserAllowedToEnableIntegrations} from '../../store/data/company/companySelectors';
import {getIntegrationsByType} from '../../store/data/dataSelectors';
import {
  createIntegrationAsyncAction,
  updateIntegrationAsyncAction,
} from '../../store/data/integrations/integrationsActions';
import {makeGetIsIntegrationDisabledViaBilling} from '../../store/data/integrations/integrationSelectors';
import {makeGetIsIntegrationTypeEnabled} from '../../store/data/integrationTypes/integrationTypesSelectors';
import {getIsUserGlobalAdmin} from '../../store/data/teammates/teammatesSelectors';
import {SettingsAppsHeaderAction} from './settingsAppsHeaderAction';

/*
 * Props.
 */

interface SettingsAppsHeaderActionContainerProps {
  integrationType?: IntegrationTypeModel;
}

/*
 * Selectors.
 */

function getIntegrationTypeId(_state: AppState, props: SettingsAppsHeaderActionContainerProps) {
  return props.integrationType?.id;
}

const getIntegration = createSelector(
  [getIntegrationTypeId, getIntegrationsByType],
  (integrationTypeId, integrations) => {
    if (!integrationTypeId) {
      return undefined;
    }
    return integrations[integrationTypeId];
  },
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsAppsHeaderActionContainerProps>()(() => ({
  isIntegrationEnabled: makeGetIsIntegrationTypeEnabled(getIntegrationTypeId),
  isUserAllowedToEnableIntegrations: getIsUserAllowedToEnableIntegrations,
  isGlobalAdmin: getIsUserGlobalAdmin,
  integration: getIntegration,
  isIntegrationDisabledViaBilling: makeGetIsIntegrationDisabledViaBilling(getIntegrationTypeId),
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  updateIntegrationAsync: updateIntegrationAsyncAction,
  createIntegrationAsync: createIntegrationAsyncAction,
}));

export const SettingsAppsHeaderActionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsAppsHeaderAction);
